import cn from 'classnames';
import { Typography } from 'seagull';
import styles from "./FormSeparator.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FormSeparatorHorizontal(props) {
  const {
    children,
    className
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.horizontalSeparatorContainer, className),
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.horizontalSeparator
    }), /*#__PURE__*/_jsx(Typography, {
      skin: "secondary",
      children: children
    }), /*#__PURE__*/_jsx("div", {
      className: styles.horizontalSeparator
    })]
  });
}
export function FormSeparatorVertical(props) {
  const {
    children
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.verticalSeparatorContainer,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.verticalSeparator
    }), /*#__PURE__*/_jsx(Typography, {
      skin: "secondary",
      children: children
    }), /*#__PURE__*/_jsx("div", {
      className: styles.verticalSeparator
    })]
  });
}